import React, { ChangeEvent } from 'react';
import Skeleton from 'react-loading-skeleton';
import downloadIcon from '../../svg/download.svg';
import Button from '../../../../generic-components/Button';
import { LiliTransaction } from '../../types/lili-transaction';
import { fileTypes } from '../../../../flows/transactions/components/TransactionReceipt';
import { CloseButton, CloseButtonColor, CloseButtonSize } from '../../../../DesignSystem/LiliCloseButton/CloseButton';
import { featureAccess, LimitedFeatureType } from '../../../../services/appAccess.service';
import { FeatureAccess } from '../../../AccountSettings/components/rolesAndPermissions/PermissionsList';

interface IProps {
  transaction: LiliTransaction;
  onClose: () => void;
  data: { type: string; url: string };
  isLoading: boolean;
  onFormDataChange: (fd: FormData) => void;
}

export const ReceiptPreviewPopup = ({ transaction, onClose, data, isLoading, onFormDataChange }: IProps) => {
  const transactionsEditPermission = featureAccess(null, LimitedFeatureType.TransactionsAddReceiptAndNote);

  const handleDownload = () => {
    if (data.url) {
      const a = document.createElement('a');
      a.href = data.url;
      a.download = 'receipt';
      a.click();
      document.removeChild(a);
    }
  };

  const handleFileInput = (e: ChangeEvent<HTMLInputElement>) => {
    if (!e?.target?.files?.[0]) return;
    const file = e.target.files[0];
    const fd = new FormData();
    fd.append('file', file, `Receipt-${transaction.transactionId}`);
    onFormDataChange(fd);
  };

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    <div
      className='fixed inset-0 bg-bw08 bg-opacity-75 backdrop-blur-sm z-[9999] flex flex-col items-center justify-center'
      onClick={onClose}
    >
      <div className='absolute top-0 py-[20px] px-[15px] z-50 w-full bg-bw08 rounded-b-[6px]'>
        <div className='flex justify-between'>
          <div className='text-bw00 font-metricR text-[16px]'>View Receipt</div>
          <div>
            <div className='flex'>
              {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-noninteractive-element-interactions */}
              <label
                onClick={(e: any) => e.stopPropagation()}
                className='border-[1px] border-bw01 cursor-pointer hover:shadow-light text-center py-[2px] rounded-[2px] font-metricR text-[12px] text-bw00 px-[12px]'
                htmlFor='replaceImage'
              >
                Replace Image
                <input
                  disabled={transactionsEditPermission !== FeatureAccess.READ_WRITE}
                  hidden
                  accept='image/*,.pdf'
                  id='replaceImage'
                  type='file'
                  placeholder='Replace Image'
                  onChange={handleFileInput}
                />
              </label>
              <Button
                onClick={handleDownload}
                className='ml-[20px]'
                id='downloadReceipt'
                childElement={<img src={downloadIcon} alt='download' />}
              />
              <CloseButton
                id='exitReceiptPopup'
                onClick={onClose}
                className='ml-[10px]'
                color={CloseButtonColor.White}
                size={CloseButtonSize.Large}
              />
            </div>
          </div>
        </div>
      </div>
      {isLoading ? (
        <Skeleton width='400px' height='600px' />
      ) : (
        <div className='bg-white relative  w-[70%] max-w-[70%] h-[90%] flex items-center justify-center pt-[80px]'>
          {data?.type === fileTypes.IMAGE && (
            <img className='object-contain w-full h-full' src={data?.url} alt='Receipt' />
          )}
          {data?.type === fileTypes.PDF && (
            <iframe className='object-contain w-full h-full' src={data?.url} title='Receipt' />
          )}
        </div>
      )}
    </div>
  );
};
